<div class="spin-loader" [ngStyle]="{'width': width, 'height': height}">
    <div class="edge edge-left bg-s60"></div>
    <div class="edge edge-right bg-s60"></div>
</div>
